export const DEFAULT_DIALOG_OPTIONS = {
  closeOnNavigation: true
};
